/* tslint:disable */
/* eslint-disable */
export enum UserVerificationRequirement {
  NotAllowed = 'not_allowed',
  Allowed = 'allowed',
  Required = 'required'
}
